import React, { useMemo } from 'react'
import { GENRE_ICONS } from '../../constants/genres';
import Icon from '../Icon';

const CreationCardV2 = ({ creation, handleViewCreation }) => {

    const getCategoryIcon = useMemo(() => {
        const categoryLower = creation?.category?.toLowerCase();
        return GENRE_ICONS[categoryLower] || 'creations';
    }, [creation?.category]);

    const isPaid = useMemo(() => creation?.price > 0, [creation?.price]);


    return (
        <div className='mycreations-card-v2-container' onClick={() => handleViewCreation(creation)}>
            <div className='mycreation-card-v2' key={creation.creation_id}>
                {creation.thumbnail_url ? (
                    <img
                        src={creation.thumbnail_url}
                        alt={creation.title}
                    />
                ) : (
                    <div className="image-placeholder-v2" />
                )}
                <div className={`category-icon ${isPaid ? 'is_second' : ''}`}>
                    <Icon
                        alias={getCategoryIcon}
                        width={20}
                        color="#FFF"
                        // className="category-icon"
                    />
                </div>
                {isPaid && (
                    <div className="ml-4 ispaid-icon" style={{ width: '16px', height: '16px' }}>
                        <Icon alias="shopping_bag" width={20} color="#FFFFFF" />
                    </div>
                )}
            </div>
            {/* <p className='fs-xs fg-grey fw-medium mb-4 mt-0'>
                <span>{`${creation.users?.firstName} ${creation.users?.lastName}`}</span>
                <span className='dot' />
                <span>{capitalizeFirstLetter(creation.tag)}</span>
            </p> */}
            <p className='fg-crea fw-medium-bold mt-0 crea-title mb-0'>{creation.title}</p>
        </div>
    )
}

export default CreationCardV2